import { useTranslation } from "react-i18next";

type PageLoaderProps = {
  label?: string;
  compact?: boolean;
};

export default function PageLoader({
  label,
  compact = false,
}: PageLoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className={`pogo-loader${compact ? " pogo-loader--compact" : ""}`}
      role="status"
      aria-atomic="true"
    >
      <div className="pogo-loader__scene" aria-hidden="true">
        <span className="pogo-loader__halo" />
        <span className="pogo-loader__orbit" />
        <span className="pogo-loader__ball" />
        <span className="pogo-loader__shadow" />
      </div>

      <div className="pogo-loader__caption">
        <span className="pogo-loader__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </div>
    </div>
  );
}
